<template>
  <div class="specialAndOverlook-box">
    <!-- 特别代理佣金分配 标题 -->
      <div class="title">
        <span class="table-title">{{multiLanguage.specialIB}}</span>
      </div>
      <!-- 特别代理佣金分配 内容 -->
      <div class="specialIB-box">
        <table class="table table-bordered table-striped" :class="{'disabled' : !enable || version == '0'}">
          <thead>
            <tr>
              <th>{{multiLanguage.allLowIB}}</th>
              <th>{{multiLanguage.ibAccount}}</th>
              <th>{{multiLanguage.ibName}}</th>
              <th>{{multiLanguage.costPerCommission}}</th>
              <th>{{multiLanguage.operate}}</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item,index) in newSpecialIB">
              <td>
                <input type="checkbox" v-model="item.withSub" @input="withSubChecked(item)" :disabled="!enable || version == '0'" >
              </td>
              <td>
                <input type="text" class="form-control" v-model="item.ibId" :disabled="!enable || version == '0'"
                  @change="checkIBFn(item,'special',errors.has(index + '_' + 'specialIbId'))"
                  v-validate="'numeric'" 
                  :name="index + '_' + 'specialIbId'"
                  :style="errors.has(index + '_' + 'specialIbId') ? 'border-color:#f44336;' : ''" >
              </td>
              <td>{{item.name}}</td>
              <td>
                <div v-for="(lev,i) in item.value" style="margin:3px 0;text-align: left;" :key="i">
                  <span style="display:inline-block;width:90px;text-align:right">{{lev.level ==0 ? ruleSettingLan.currentSetting : item.value.length - lev.level + ruleSettingLan.levelSetting}}</span>
                  <input type="text" class="form-control form-control-small" v-model="lev.rebate" :disabled="!enable || version == '0'"
                    v-validate="lev.ibId ? 'required|min_value:0.00|decimal:2' : 'min_value:0.00|decimal:2'"
                    :name="index + '_' + 'specialRebate'"
                    :style="errors.has(index + '_' + 'specialRebate') ? 'border-color:#f44336;' : ''"  >
                  <span>
                    <el-button :style="version == '0' ? 'visibility:hidden;' : ''" type="warning" size="small" :disabled="!enable" @click="removeItemLev(index,i,newSpecialIB)">{{multiLanguage.btnGroup.remove}}</el-button>
                    <el-button v-if="i==0" :style="version == '0' ? 'visibility:hidden;' : ''" type="primary" size="small" :disabled="!enable" @click="addItemLev(index,i,newSpecialIB)">{{multiLanguage.btnGroup.add}}</el-button>
                  </span>
                </div>
              </td>
              <td>
                <button :style="version == '0' ? 'visibility:hidden;' : ''" class="btn btn-style-add" :disabled="!enable" @click="addItem(index,newSpecialIB)">{{multiLanguage.btnGroup.add}}</button>
                <button :style="version == '0' ? 'visibility:hidden;' : ''" class="btn btn-style-remove" :disabled="!enable" @click="removeItem(index,newSpecialIB)">{{multiLanguage.btnGroup.remove}}</button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <!-- 被忽略的代理 标题-->
      <div class="title">
        <span class="table-title">{{multiLanguage.overlookIB}}</span>
      </div>
      <!-- 被忽略的代理 内容-->
      <div class="overlookIB-box">
        <table class="table table-bordered table-striped" :class="{'disabled' : !enable}">
          <thead>
            <tr>
              <th>{{multiLanguage.allLowIB}}</th>
              <th>{{multiLanguage.ibAccount}}</th>
              <th>{{multiLanguage.ibName}}</th>
              <th>{{multiLanguage.operate}}</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item,index) in newOverlookIB">
              <td>
                <input type="checkbox" v-model="item.withSub" :disabled="!enable || version == '0'">
              </td>
              <td>
                <input type="text" class="form-control" v-model="item.ibId" :disabled="!enable || version == '0'"
                  @change="checkIBFn(item,'ignore',errors.has(index + '_' + 'overlookIbId'))"
                  v-validate="'numeric'" 
                  :name="index + '_' + 'overlookIbId'"
                  :style="errors.has(index + '_' + 'overlookIbId') ? 'border-color:#f44336;' : ''" >
              </td>
              <td>{{item.name}}</td>
              <td>
                <button :style="version == '0' ? 'visibility:hidden;' : ''" class="btn btn-style-add" :disabled="!enable" @click="addItem(index,newOverlookIB)">{{multiLanguage.btnGroup.add}}</button>
                <button :style="version == '0' ? 'visibility:hidden;' : ''" class="btn btn-style-remove" :disabled="!enable" @click="removeItem(index,newOverlookIB)">{{multiLanguage.btnGroup.remove}}</button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
  </div>
</template>

<script>
  import { URL_SALESCHECK } from 'api/commissionApi'
  import { Api } from 'api/commissionEnv'
  var api = new Api()
  export default {
    mixins: [
      require("common/mixin/base.js").base({ruleSettingLan:"ruleItem"}),
    ],
    props: {
      version: {
        type: String,
        default: ''
      },
      enable: {
        type: Boolean,
        default: false,
      },
      multiLanguage: { // 多语言
        type: Object,
        default: {}
      },
      specialIB: { // 特别代理
        type: Array,
        default: []
      },
      overlookIB: { // 被忽视的代理
        type: Array,
        default: []
      },
      curArea: {
        type: String,
        default: '',
      }
    },
    computed: {
      newSpecialIB () { // 新的 特别代理
        return this.specialIB
      },
      newOverlookIB () { // 新的 被忽视的代理
        return this.overlookIB
      }
    },
    methods: {
      addItem (index,arr) { // 添加
        let tem = {}
        let keys = Object.keys(arr[0])
        keys.forEach(key => { key == 'withSub' ? tem[key] = true : tem[key] = '' })
        tem.value = [{level:0,rebate:''}];
        arr.splice(index+1,0,tem)
      },
      removeItem (index,arr) { //删除
        if (arr.length > 1) {
          let msg = this.multiLanguage.btnGroup.confirmDeleteText
          if (confirm(msg) == true) arr.splice(index,1)
        }
      },
      addItemLev (index,i,arr) {
        let tem = {}
        tem.level = arr[index].value.length
        tem.rebate = ''
        arr[index].value.unshift(tem)
      },
      removeItemLev (index,i,arr) {
        if (arr[index].value.length > 1) {
          let msg = this.multiLanguage.btnGroup.confirmDeleteText
          if (confirm(msg) == true) {
            const lev = arr[index].value[i].level
            arr[index].value.splice(i,1);
            arr[index].value.forEach(it=>{
              if(it.level >= lev) it.level -= 1;
            })
          }
        }
      },
      withSubChecked (item) {
        setTimeout(()=>{
          item.forEach(it=>{
            it.withSub = item[0].withSub
            it.ibId = item[0].ibId
          })
        },0)
      },
      checkIBFn (item,type,faulty) { // 检查是不是代理
        if (faulty) return 
        else { // localhost:3010/GM/sales/check?salesId=6218908&ibId=680000033&type=ignore
          this.$http.get(api.getUrl20(this.curArea,URL_SALESCHECK),{params: {salesId: this.$route.query.id,ibId: item.ibId,type: type}}).then(res => {
            let data = res.data.data
            if (data.name) item.name = data.name
            else {
              alert(data)
              item.ibId = ''
              item.name = ''
            }
          })
        }
      }
    }
  }
</script>


<style lang="scss" scoped>
  .specialAndOverlook-box{
    margin-top: 20px;
    .title{
      border-bottom: 2px solid #3F51B5;
      span{
        color: #3F51B5;
        font-weight: 550;
        font-size: 15px;
      }
      .table-title{
        font-size: 20px;
        margin-left: 20px;
      }
    }
    .specialIB-box,.overlookIB-box{
      input[type='checkbox']{
        width: 22px;
        height: 22px;
      }
      .form-control{
        display: inline-block;
        width: 70%;
      }
      .form-control-small{
        display: inline-block;
        width: 40%;
      }
      table{
        text-align: center;
        thead {
          background: #EBEDF7;
        }
        thead tr th {
          text-align: center;
        }
        td {
          white-space: nowrap;
          overflow-x: auto;
        }
      }
    }
    .specialIB-box{
      margin: 20px 0;
    }
    .overlookIB-box{
      margin-top: 20px;
    }
    .btn-style-add {
      background-color: #3f51b5;
      color:#fff;
    }
    .btn-style-remove {
      background-color:#f08712;
      color:#fff;
    }
  }
</style>



// WEBPACK FOOTER //
// specialAndOverlook.vue?3222eef4